import { apiPost } from 'shared/services/api/resource';
import { CancellationWindow, OnboardingCourt, OnboardingTeamMember } from 'modules/arena/onboarding/types';

export interface OnboardingSubmission {
  arenaName: string;
  unitName: string;
  address: string;
  city: string;
  selectedSportIds: string[];
  courts: OnboardingCourt[];
  openDays: string[];
  openTime: string;
  closeTime: string;
  team: OnboardingTeamMember[];
  cancellationWindow: CancellationWindow;
  refundPercentage: number;
  planId: string;
}

export function submitOnboarding(submission: OnboardingSubmission): Promise<{ arenaId: string }> {
  return apiPost({ arenaId: `arena-${Math.random().toString(36).slice(2, 9)}` }, '/arenas/onboarding', submission, 500);
}
